
import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useRole } from '@/contexts/RoleContext';

interface AdminRouteProps {
  children: ReactNode;
  redirectTo?: string;
}

const AdminRoute = ({ 
  children, 
  redirectTo = '/'
}: AdminRouteProps) => {
  const { user, isLoading: authLoading, isDevMockUser } = useAuth();
  const { isAdmin, loading: roleLoading } = useRole();

  // In development mode, always allow access
  if (isDevMockUser) {
    return <>{children}</>;
  }

  // Show loading state
  if (authLoading || roleLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Check if we have a user and they are an admin
  if (!user || !isAdmin) {
    return <Navigate to={redirectTo} replace />;
  }

  // Render children if admin
  return <>{children}</>;
};

export default AdminRoute;
